import { gql } from '@apollo/client';

export const UPDATE_SHOPPING_LIST_NAME = gql`
    mutation UpdateShoppingListName($id: String!, $shoppingListInput: ShoppingListInput!) {
        updateShoppingListName(id: $id, shoppingListInput: $shoppingListInput) {
            name
        }
    }
`;
